import * as React from 'react';

interface Props {
	inputClassName?: string;
	onEnter: (text: string) => void;
	showInput?: boolean;
}

const ManualInput: React.FC<Props> = ({ children, inputClassName, onEnter, showInput }) => {
	const [isInputActive, setInputActive] = React.useState(false);

	const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInputActive(!!e.target.value);
	};

	const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.keyCode === 13) {
			e.preventDefault();

			onEnter((e.target as HTMLInputElement).value);
		}
	};

	React.useEffect(() => {
		if (!showInput) {
			setInputActive(false);
		}
	}, [showInput]);

	return (
		<>
			{showInput && (
				<input
					type="text"
					autoFocus={true}
					className={inputClassName}
					onChange={onInputChange}
					onKeyDown={onKeyDown}
				/>
			)}

			{!isInputActive && children}
		</>
	);
};

export default ManualInput;
